import React, { createContext, useState, useContext, useEffect, useCallback } from "react";
import authContext from "contexts/auth/authContext";

export const ViewOnlyPermissionsContext = createContext({
    allVOPermissions: {},
    sharedVOPermissions: {},
});

export const ViewOnlyPermissionsProvider = ({ children }) => {
    const { user } = useContext(authContext);
    const [allVOPermissions, setAllVOPermissions] = useState({});
    const [viewOnlyAdmin, setViewOnlyAdmin] = useState({});
    const [viewOnlyShipment, setViewOnlyShipment] = useState({});

    const [isShipment, setIsShipment] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    const handleShipmentCheck = useCallback((isShipmentScreen) => setIsShipment(isShipmentScreen), []);

    const handleAdminCheck = useCallback((isAdminScreen) => setIsAdmin(isAdminScreen), []);

    useEffect(() => {
        if (user && user.permissions) {
            setAllVOPermissions(
                user.permissions.reduce((allPermissions, current) => {
                    if (current.isReadOnly) {
                        allPermissions[current.name] = current.isReadOnly;
                    }

                    return allPermissions;
                }, {})
            );
        }
    }, [user, user.permissions]);

    useEffect(() => {
        if (allVOPermissions && isShipment) {
            setViewOnlyShipment({
                createNote: allVOPermissions["create:shipmentnote"],
                createShipment: allVOPermissions["create:shipment"],
                disableAddPaperwork: allVOPermissions["add:paperworktoshipment"],
                disableAddSupplier: allVOPermissions["create:suppliername"],
                disableCompleteMeasurements: allVOPermissions["complete:redomeasurements"],
                disableSalesSample: allVOPermissions["update:productassalessample"],
                disableUPCDelete: allVOPermissions[`delete:upcfromshipment`],
                deleteShipment: allVOPermissions[`delete:shipment`],
            });
        }
    }, [allVOPermissions, isShipment]);

    useEffect(() => {
        if (allVOPermissions && isAdmin) {
            setViewOnlyAdmin({
                accessPackageLinkingTool: allVOPermissions["access:packagehierarchylinkingtool"],
                addRolePermissions: allVOPermissions["add:rolepermissions"],
                assignToTeam: allVOPermissions[`assign:producttoteaminassignmentarea`],
                assignToUser: allVOPermissions[`assign:producttouserinassignmentarea`],
                createAssignmentNote: allVOPermissions["create:assignmentnote"],
                createBrand: allVOPermissions["create:brand"],
                createManufacturer: allVOPermissions["create:manufacturer"],
                deleteRolePermissions: allVOPermissions["delete:rolepermissions"],
                downloadBrands: allVOPermissions["download:brandlist"],
                downloadManufacturers: allVOPermissions["download:manufacturerlist"],
                resubmitWithUpdate: allVOPermissions["resubmit:productwithpostdateupdate"],
                resubmitWithoutUpdate: allVOPermissions["resubmit:productwithoutpostdateupdate"],
                returnToIntake: allVOPermissions["redo:finalqa"],
                setImageApproval: allVOPermissions["set:clientimageapprovalatclientlevel"],
                setPremiumEditing: allVOPermissions["set:premiumeditingatclientlevel"],
                setSendToGDSN: allVOPermissions["set:sendtogdsnatclientlevel"],
                updateAttributes: allVOPermissions["update:attributesettings"],
                updateBrand: allVOPermissions["update:brand"],
                updateManufacturer: allVOPermissions["update:manufacturer"],
                uploadAttributes: allVOPermissions["upload:attributesettingsfile"],
                viewAttributes: allVOPermissions["view:attributesettings"],
            });
        }
    }, [allVOPermissions, isAdmin]);

    return (
        <ViewOnlyPermissionsContext.Provider value={{ allVOPermissions, handleAdminCheck, viewOnlyAdmin, handleShipmentCheck, viewOnlyShipment }}>
            {children}
        </ViewOnlyPermissionsContext.Provider>
    );
};
